<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-medium"
    title="個別サービス設定参照"
  >
    <template v-slot:body="{ cancel }">
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <v-row>
              <v-col class="text-right">
                <v-btn
                  v-permission.config
                  color="primary"
                  @click="showServiceIntranetFwModify"
                  >変更
                </v-btn>
                <v-btn
                  v-permission.config
                  v-show="!customServiceIntranet.isPolicyInUse"
                  color="primary"
                  class="ml-2"
                  @click="deleteServiceSetting"
                  >削除
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <app-label-group
                  label="名前"
                  :value="customServiceIntranet.serviceName"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <app-label-group
                  label="プロトコル"
                  :value="customServiceIntranet.protocol"
                />
              </v-col>
            </v-row>
            <template
              v-if="
                customServiceIntranet.protocol === 'TCP' ||
                customServiceIntranet.protocol === 'UDP'
              "
            >
              <v-row>
                <v-col cols="12">
                  <app-label-group
                    label="Port"
                    :value="customServiceIntranet.portNumber"
                  />
                </v-col>
              </v-row>
            </template>
            <template v-else-if="customServiceIntranet.protocol === 'IP'">
              <v-row>
                <v-col cols="12">
                  <app-label-group
                    label="プロトコル番号"
                    :value="customServiceIntranet.protocolNumber"
                  />
                </v-col>
              </v-row>
            </template>
            <template v-else>
              <v-row>
                <v-col cols="12">
                  <app-label-group
                    label="ICMP Type"
                    :value="customServiceIntranet.icmpType"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <app-label-group
                    label="ICMP Code"
                    :value="customServiceIntranet.icmpCode"
                  />
                </v-col>
              </v-row>
            </template>
            <v-row>
              <v-col cols="12">
                <app-label-group
                  label="備考"
                  :value="
                    $filter.emptyTo(customServiceIntranet.description, '-')
                  "
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <app-label-group
                  label="ポリシー使用有無"
                  :value="
                    $filter.enumTo(
                      customServiceIntranet.isPolicyInUse,
                      'isPolicyInUse'
                    )
                  "
                />
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >戻る
            </v-btn>
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { CustomServiceIntranet } from "@/apis/CustomServiceApi";
import { VueFinalModal } from "vue-final-modal";
import AppLabelGroup from "@/components/AppLabelGroup.vue";
import ServiceIntranetFwEdit from "@/modals/applianceObject/ServiceIntranetFwEdit.vue";

export default defineComponent({
  name: "ServiceIntranetFwReference",
  components: { AppLabelGroup },
  props: {
    /**
     * ポリシー種別
     * INTRANET_FW ：イントラネットFW
     * INTRANET_FW_PFGW ：イントラネットFW（PFGW）
     */
    policyType: {
      type: String as PropType<"INTRANET_FW" | "INTRANET_FW_PFGW">,
      required: true,
    },
    /**
     * E番号(ACT)
     * ポリシー種別でINTRANET_FW_PFGWを指定時必須
     */
    enumberAct: {
      type: String as PropType<string>,
      default: undefined,
    },
    customServiceIntranet: {
      type: Object as PropType<CustomServiceIntranet>,
      required: true,
    },
    customServiceKeyId: {
      type: String as PropType<string>,
      required: true,
    },
  },
  methods: {
    /** サービス(イントラネットFW)変更モーダルを表示 */
    async showServiceIntranetFwModify() {
      await this.$modal.show(ServiceIntranetFwEdit, {
        policyType: this.policyType,
        enumberAct: this.enumberAct,
        customServiceIntranet: this.customServiceIntranet,
        customServiceKeyId: this.customServiceKeyId,
      });
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
    /** サービス(イントラネットFW)を削除 */
    async deleteServiceSetting() {
      await this.$confirm(`個別サービスを削除します。よろしいですか？`);
      await this.$api.customServiceApi.deleteIntranetfwCustomService(
        this.policyType,
        this.enumberAct,
        {
          customServiceSeqList: [this.customServiceIntranet.customServiceSeq],
          customServiceKeyId: this.customServiceKeyId,
        }
      );
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
  },
});
</script>
